export default {"src":"/_next/static/media/SplineA_Pg1Dark_1441x520.c0c2cdc5.svg","height":520,"width":1441,"blurWidth":0,"blurHeight":0};